import React, { useState, useEffect } from "react";
import API from "../../API";
import { bindClick } from '@arema/components/Util';
import { Button, Header } from 'react-frontier2';
import { BankAccount } from "@arema/components/Classes";
import { BankAccountModal } from '../../components';

interface Props {
	promoter_id?: number,
	onEditPromoter?: Function,
}

const PromoterAccountsList = (props: Props)=>{
	var [accounts, setAccounts] = useState<BankAccount[]>(null);
	var [loadError, setLoadError] = useState<string>(null);
	var [viewingAccount, setViewingAccount] = useState<number>(null);
	var [createModal, setCreateModal] = useState<boolean>(false);

	var loadAccounts = ()=>{
		API.getPromoterBankAccounts(props.promoter_id).then(res=>{
			if(res.error) return setLoadError(res.message);
			setAccounts(res.data);
		}).catch(err=>{
			setLoadError('Hubo un error cargando las cuentas. (LCL-1)');
		});
	}

	useEffect(()=>{
		if(!accounts){
			loadAccounts();
		}
	}, []);

	const showCreate = ()=>{
		setViewingAccount(null);
		setCreateModal(true)
	}

	const onSaveAccount = (account: BankAccount) => {
		setCreateModal(false);
		var cts = [...accounts];
		var ix = cts.findIndex(a=>a.account_id==account.account_id);
		if(ix==-1){
			cts.push(account);
		}else{
			cts[ix] = account;
		}
		setAccounts(cts);
	}

	const viewAccount = (account_id: number) => {
		return ()=>{
			setViewingAccount(account_id);
			setCreateModal(true);
		}
	}

	if(loadError) return <Header text="Error" subtext={loadError} />
	if(!accounts) return <Header loading text="Cargando cuentas" />

	return (
		<div>
			<table className="fr selectable table" style={{ margin: 'auto', maxWidth: 800 }}>
				<thead>
					<tr>
						<th colSpan={3} className="title">Cuentas bancarias</th>
						<th colSpan={6} style={{ textAlign: 'right' }}>
							<Button size='tiny' text="Crear" iconName='add' color='black' onClick={showCreate} />
						</th>
					</tr>
					<tr>
						<th className="collapsing">ID</th>
						<th>Nombre</th>
						<th>Email</th>
						<th>RFC</th>
						<th>Cuenta</th>
					</tr>
				</thead>
				<tbody>
					{accounts.length==0 ? (
						<tr className="normal">
							<td colSpan={7} className="empty">El promotor no tiene cuentas bancarias</td>
						</tr>
					) : (
						accounts.map(a=>(
							<tr key={`accnt-${a.account_id}`} onClick={viewAccount(a.account_id)}>
								<td className="collapsing">{a.account_id}</td>
								<td>{a.name_account}</td>
								<td>{a.email_account}</td>
								<td className="collapsing">{a.rfc}</td>
								<td className="collapsing">
									<i className={`${a.clabe ? 'money check alt' : 'credit card'} icon`}></i>
									{a.bank} {' '}
									**{(a.clabe || a.card_number).slice(-4)}
								</td>
							</tr>
						))
					)}
				</tbody>
			</table>

			<BankAccountModal 
				open={createModal} 
				onClose={bindClick(setCreateModal)} 
				onCreate={onSaveAccount} 
				promoter={props.promoter_id}
				accountId={viewingAccount}
			/>

		</div>
	)
}

export default PromoterAccountsList;